export const tableColumns = [
    {
        Header: 'Discipline',
        accessor: 'discipline',
        width: 130,
    },
    {
        Header: 'Date',
        accessor: 'daily_date',
        width: 70,
        Cell: (cell) => {
            const row = cell.row.original;
            let dailyId = typeof row !== 'undefined' ? row.daily_id : null;
            return (
                <a
                  href={`/data_entry/daily/daily/edit/${dailyId}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <b>{cell.value}</b>
                </a>
              );
        }
    },
    {
        Header: 'Shift',
        accessor: 'daily_shift',
        width: 60,
    },
    {
        Header: 'Rig',
        accessor: 'rig_name',
        width: 60,
    },
    {
        Header: 'Client',
        accessor: 'client_name',
        width: 200,
    },
    {
        Header: 'Job',
        accessor: 'job_number',
        width: 90,
    },
    {
        Header: 'Footage',
        accessor: 'depth_total',
        width: 60,
    },
    {
        Header: 'Depth',
        accessor: 'depth_to',
        width: 60,
    },
    {
        Header: 'Toolpusher',
        accessor: 'created_by',
        width: 150,
    },
    {
        Header: 'Driller Notes',
        accessor: 'notes',
    },
];
